import { api } from "@/lib/api";
import { loadTags, disableGa } from "@/lib/analytics";

const KEY = "epl_cookie_consent";

export const getConsent = () => localStorage.getItem(KEY);
export const hasConsent = () => getConsent() === "granted";

export const setConsent = (value) => {
  localStorage.setItem(KEY, value);
  if (value === "granted") loadTags();
  else {
    window.fbq?.("consent", "revoke");
    disableGa();
  }
  window.dispatchEvent(new Event("epl-consent"));
};

export const openCookieSettings = () => window.dispatchEvent(new Event("epl-open-cookies"));

const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1] || "";
export const metaIds = () => ({ fbp: cookie("_fbp"), fbc: cookie("_fbc") });
export const newEventId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

// Browser Pixel + server Conversions API share one event ID for deduplication.
// Only the programme id, AUD value and player count are sent — never player, parent or medical data.
export const metaEvent = (name, { contentId, value, numItems } = {}, eventId = newEventId()) => {
  if (!hasConsent()) return;
  const params = { content_ids: [contentId], content_type: "product", currency: "AUD" };
  if (value !== undefined) params.value = value;
  if (numItems) params.num_items = numItems;
  window.fbq?.("track", name, params, { eventID: eventId });
  if (name === "Purchase") return;
  api.post("/meta/events", { event_name: name, event_id: eventId, event_source_url: window.location.href, content_id: contentId, value, num_items: numItems, ...metaIds() },
    { headers: { "X-Marketing-Consent": "true" } }).catch(() => {});
};
